import apiClient from './api';
import { PurchaseReturn, CreatePurchaseReturnDto, UpdatePurchaseReturnDto, InvoiceItemForReturn } from '../types/purchaseReturns.types';

export const purchaseReturnsService = {
  async getAll(status?: string, supplierId?: number, warehouseId?: number, fromDate?: string, toDate?: string): Promise<PurchaseReturn[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (supplierId) params.append('supplierId', supplierId.toString());
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    
    const response = await apiClient.get(`/PurchaseReturns?${params.toString()}`);
    return response.data;
  },

  async getById(id: number): Promise<PurchaseReturn> {
    const response = await apiClient.get(`/PurchaseReturns/${id}`);
    return response.data;
  },

  async create(data: CreatePurchaseReturnDto): Promise<PurchaseReturn> {
    const response = await apiClient.post('/PurchaseReturns', data);
    return response.data;
  },

  async update(id: number, data: UpdatePurchaseReturnDto): Promise<PurchaseReturn> {
    const response = await apiClient.put(`/PurchaseReturns/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/PurchaseReturns/${id}`);
  },

  async post(id: number): Promise<PurchaseReturn> {
    const response = await apiClient.post(`/PurchaseReturns/${id}/post`);
    return response.data;
  },

  async unpost(id: number): Promise<PurchaseReturn> {
    const response = await apiClient.post(`/PurchaseReturns/${id}/unpost`);
    return response.data;
  },

  async generateReturnNumber(): Promise<string> {
    const response = await apiClient.get('/PurchaseReturns/generate-code');
    return response.data;
  },

  // ✅ NEW: Get invoice items for return
  async getInvoiceItems(invoiceId: number): Promise<InvoiceItemForReturn[]> {
    const response = await apiClient.get(`/PurchaseReturns/invoice/${invoiceId}/items`);
    return response.data;
  }
};